import { prodConfig, defaultConfig, devConfig, commonConfig } from '../config';
import { Config, DefaultConfig } from '../config/Config';

import { Environment, ShopBundle } from '@types-internal';

/*
 *  The default configuration is the one common to all environments. In particular, it holds enough information to initialize a SentryService.
 */
export function getDefaultConfig(): DefaultConfig {
  return {
    appVersion: process.env.REACT_APP_VERSION ?? 'unknown',
    ...defaultConfig,
  };
}

const isBrowser = () => globalThis.window !== undefined;

export const selectConfig = (env: Environment) => {
  if (isBrowser() && !globalThis.window.Payment) {
    globalThis.window.Payment = {};
  }

  return (shopBundle: ShopBundle = 'zooplus') => {
    const envConfig = env === 'prod' ? prodConfig : devConfig;

    const mergedShopConfig = {
      ...commonConfig[shopBundle],
      ...envConfig.shopCommon,
      ...envConfig[shopBundle],
    };

    const config: Config = { env, ...getDefaultConfig(), ...mergedShopConfig };
    if (isBrowser()) {
      globalThis.window.Payment.__APP_RUNNING_CONFIG__ = config;
    }

    return config;
  };
};
